import React from "react";
import { Reveal, SectionEyebrow } from "@/components/shared/Reveal";
import { PULSE_METHOD } from "@/lib/pulseConstants";

export default function PulseMethodSection() {
    return (
        <section
            className="section-pad relative border-y border-white/10 bg-[#0A0B10] hidden md:block"
            data-testid="home-pulse-method-section"
        >
            <div className="container-editorial">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-12">
                    <div className="lg:col-span-6">
                        <SectionEyebrow index="05" label="The Pulse Method" />
                        <Reveal>
                            <h2 className="display-2 text-white text-balance">
                                From brand objective
                                <br />
                                to <span className="text-[#FF2A2A]">cultural moment.</span>
                            </h2>
                        </Reveal>
                    </div>
                    <div className="lg:col-span-6 flex items-end">
                        <Reveal delay={0.1}>
                            <p className="body-md max-w-md">
                                A focused process that connects strategy, audience, experience and amplification.
                            </p>
                        </Reveal>
                    </div>
                </div>

                <ol className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
                    {PULSE_METHOD.map((s, i) => (
                        <Reveal key={s.step} delay={0.05 * i}>
                            <li className="h-full rounded-2xl border border-white/10 bg-[#0B0C10] p-6 hover:border-[#FF2A2A]/40 transition-colors relative overflow-hidden group">
                                <div className="flex items-center justify-between mb-6">
                                    <span className="font-display text-5xl text-white/70 group-hover:text-[#FF2A2A] transition-colors">
                                        {s.step}
                                    </span>
                                    <span className="h-6 w-6 rounded-full border border-white/20 grid place-items-center text-[10px] font-mono text-white/60">
                                        {i < PULSE_METHOD.length - 1 ? "→" : "▲"}
                                    </span>
                                </div>
                                <h3 className="font-display text-2xl leading-tight text-white mb-3">{s.title}</h3>
                                <p className="text-sm text-white/70 leading-relaxed">{s.body}</p>
                            </li>
                        </Reveal>
                    ))}
                </ol>
            </div>
        </section>
    );
}
